import styled from "styled-components";

export const Styled = styled.div`
  width: 100%;

  .ant-row {
    height: calc(100vh - 70px - 140px);
    font-size: 18px;
    color: #434343;

    h2 {
      font-size: 24px;
      color: inherit;
    }

    .anticon {
      font-size: 72px !important;
    }
  }
`;
